<template>
  <v-container class="fill-height flex-column pa-0">
    <div class="text-center mt-10">
      <p class="text-h5 mb-4">{{ $t('message.updating.broken') }}</p>
      <p>
        {{ $t('message.updating.underMaintenance') }}
        <br />
        <i18n path="message.updating.tryLater">
          <a :href="$route.path">{{ $t('message.updating.refreshPage') }}</a>
        </i18n>
      </p>
    </div>
    <div class="align-self-end mt-auto">
      <img src="@/assets/images/scientist.png" alt="" class="img-scientist" />
    </div>
  </v-container>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.$t('message.updating.title'),
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/settings/_variables.scss';

.img-scientist {
  display: block;
  max-width: 320px;
  @media #{map-get($display-breakpoints, 'sm-and-up')} {
    max-width: 500px;
  }
}
</style>
